module.exports = __webpack_public_path__ + "static/media/teller.6949013b.svg";